const SCHEMAS = {
  AVAILABILITIES: {
    LIMITED_AVAILABILITY: 'LimitedAvailability',
    PRE_SALE: 'PreSale',
    SOLD_OUT: 'SoldOut',
  },
};

export default SCHEMAS;
